//#region ../src/sensors/device-orientation-cache.ts
let lastDeviceOrientation = null;
/**
* Update the cached device orientation.
* Called by the host's orientation watch; read when a GPS event arrives and
* by the XR frame loop's orientation snapshot.
*/
function updateDeviceOrientation(orientation) {
	lastDeviceOrientation = orientation;
}
/** Get the current cached device orientation (null before the first reading). */
function getLastDeviceOrientation() {
	return lastDeviceOrientation;
}
/** Clear the cache (testing / session reset). */
function resetDeviceOrientationCache() {
	lastDeviceOrientation = null;
}
//#endregion
export { resetDeviceOrientationCache as n, updateDeviceOrientation as r, getLastDeviceOrientation as t };
